var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guide-Champion-WebSDK-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Champion_Icons_library",
    transform: "translate(-200.000000, -956.000000)",
    fill: "#5E10B1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(200.000000, 429.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/icon-help",
    transform: "translate(0.000000, 527.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,18.6272727 18.6261818,24 12,24 C5.37381818,24 0,18.6272727 0,12 C0,5.37272727 5.37381818,0 12,0 C18.6261818,0 24,5.37272727 24,12 Z M21.8181818,12 C21.8181818,6.58581818 17.4141818,2.18181818 12,2.18181818 C6.58581818,2.18181818 2.18181818,6.58581818 2.18181818,12 C2.18181818,17.4141818 6.58581818,21.8181818 12,21.8181818 C17.4141818,21.8181818 21.8181818,17.4141818 21.8181818,12 Z M10.9090909,16.3636364 L13.0909091,16.3636364 L13.0909091,18.5454545 L10.9090909,18.5454545 L10.9090909,16.3636364 Z M12.1189091,6.17236364 C10.3352727,6.17236364 8.97381818,6.83454545 7.93636364,8.26363636 L9.63927273,9.70909091 C10.4847273,8.43272727 11.1174545,8.12836364 11.9683636,8.12836364 C13.0232727,8.12836364 13.632,8.62036364 13.6690909,9.50290909 C13.6690909,10.4563636 13.1367273,10.9854545 12.4396364,11.4949091 C11.6378182,12.0556364 10.9090909,12.6501818 10.9090909,14.028 L10.9090909,15.2727273 L13.0909091,15.2727273 L13.0909091,14.0792727 C13.0909091,13.5523636 13.5043636,13.1945455 14.1349091,12.7854545 C14.9869091,12.2094545 16.0909091,11.3912727 16.0909091,9.52145455 C16.0909091,7.41490909 14.568,6.17236364 12.1189091,6.17236364 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipInfo);
export default __webpack_public_path__ + "static/media/tooltipInfo.b1a828a5937fda165fb1069dad41bedb.svg";
export { ForwardRef as ReactComponent };